import React from 'react';
import { utilizationBarColor } from './healthDashboardUtils';

interface Props {
  used: number;
  capacity: number;
  percent?: number | null;
  showCounts?: boolean;
  className?: string;
}

const UtilizationBar: React.FC<Props> = ({
  used,
  capacity,
  percent,
  showCounts = true,
  className = '',
}) => {
  const pct =
    percent != null && Number.isFinite(percent)
      ? percent > 1
        ? percent / 100
        : percent
      : capacity > 0
        ? used / capacity
        : 0;
  const displayPct = Math.round(pct * 100);

  return (
    <div className={`min-w-[88px] ${className}`}>
      {showCounts && (
        <p className="text-xs tabular-nums text-muted-foreground mb-1">
          {used}/{capacity > 0 ? capacity : '—'}
        </p>
      )}
      <div className="flex items-center gap-2">
        <div className="flex-1 h-1.5 max-w-[72px] rounded-full bg-muted overflow-hidden">
          <div
            className={`h-full rounded-full transition-all ${utilizationBarColor(pct)}`}
            style={{ width: `${Math.min(100, displayPct)}%` }}
          />
        </div>
        <span className="text-xs tabular-nums font-medium">{displayPct}%</span>
      </div>
    </div>
  );
};

export default UtilizationBar;
